import Link from "next/link";
import { buildUrlName } from "../../../lib/generic";
import React from "react";
import { Listing } from "../../../interfaces/training-plan/Listing";

type BlogCardLinkProps = {
  blog: Listing;
  children: React.ReactNode;
};

export const BlogCardLink = ({ blog, children }: BlogCardLinkProps) => {
  return (
    <Link
      href={{
        pathname: "/blog/[id]/[name]",
        query: {
          id: blog.id,
          name: buildUrlName(blog.title),
        },
      }}
    >
      {children}
    </Link>
  );
};
